import Promise from 'bluebird';
import assign from 'lodash/assign';
import { normalize } from 'normalizr';
import { types } from '../schemas/index';
import isArray from 'lodash/isArray';

const toArray = input => (isArray(input) ? input : [input]);

const flatten = (input) => {
    // flatten poll dependecy if needed
    if (input.type === 'contest' && input.attributes.hasQuestions) {
        input.relations.poll.data = flatten(input.relations.poll.data);
    }
    return assign({ id: input.id, type: input.type, relations: input.relations }, input.attributes);
};

const reducer = (output, { id, schema }) => {
    // plular
    const type = `${schema}s`;

    switch (type) {
        case 'users':
        case 'participants':
            output.users.push(id);
            break;

        case 'contests':
        case 'polls':
        case 'pollAnswers':
            output[type].push(id);
            break;

        default: {
            const container = output[type];
            if (container) {
                container.unshift(id);
            } else {
                // eslint-disable-next-line no-console
                console.warn('unable to find type "%s" for id', type, id);
            }
        }
    }

    return output;
};

export default function parse({ errors, meta, data }) {
    if (errors) {
        return Promise.reject(errors);
    }

    const input = toArray(data).map(flatten);
    const response = normalize(input, types);

    // normalize response
    response.entities = assign({
        messages: {},
        users: {},
        pins: {},
        events: {},
        contests: {},
        polls: {},
        pollAnswers: {},
        rooms: {},
    }, response.entities);

    // map response result and normalize order at the same time
    // all must have desc order
    response.result = response.result.reduce(reducer, {
        users: [],
        messages: [],
        pins: [],
        events: [],
        contests: [],
        polls: [],
        pollAnswers: [],
        rooms: [],
        length: response.result.length,
    });

    // resolve this
    return Promise.resolve(assign({ meta }, response));
}
